import _debounce from 'lodash/debounce';
import React, { useEffect } from 'react';
import { sharedTableStyles } from '../../../../utils/tableStyles';
import { TableSkeleton } from '../../../../components/UI/Skeleton/Skeleton';
import RowActionMenu from '../../../../components/UI/RowActionMenu/RowActionMenu';
import TableCard from '../../../../components/UI/TableToolbar/TableCard';
import TableToolbar from '../../../../components/UI/TableToolbar/TableToolbar';
import { BT_BUTTON_LABELS } from '../../../../utils/constant/buttons';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';

import {
  useGetLopOvertimeRequestQuery,
  useDeleteLopOvertimeRequestMutation
} from '../../../../redux/apis/LOPAndOvertimeAPI';
import {
  setState,
  selectedLopOvertimeRequest
} from '../../../../redux/Slice/lopOvertimeRequestSlice';
import { useIsLoggedInQuery } from '../../../../redux/apis/authApi';

import EmptyData from '../../../../components/UI/EmptyData';
import DeleteModel from '../../../../components/common/DeleteModel';
import { DepartmentsData } from '../../../../components/Data/AppData';

import {
  LB_HEADER,
  LB_LOP_OVERTIME_TABLE_COLS,
  LB_EMPLOYEE_TABLE_COLS_SORT,
  LB_LOP_OVERTIME_MODULE
} from '../../../../utils/constant/labels';
import { notification } from '../../../../utils/notification';
import { TOAST_TYPE } from '../../../../utils/constant/errorMessage';
import { formatDate, paginationRow, skipRow } from '../../../../utils/handler';
import { INPUT_LABEL } from '../../../../utils/constant/placeHolders';
import { GLOBAL, LOP_AND_OVERTIME_STATUS, ROLES } from '../../../../utils/constant/global';

import LopAndOvertimeRequestApprovedModel from './LopAndOvertimeRequestApprovedModel';
import LopAndOvertimeRequestRejectedModel from './LopAndOvertimeRequestRejectedModel';
import './LopAndOvertimeRequestTable.scss';

const {
  LB_TBL_COL_NAME,
  LB_TBL_COL_DAYS,
  LB_TBL_COL_ACTION,
  LB_TBL_COL_REASON,
  LB_TBL_COL_CLAIM_DATE,
  LB_TBL_COL_REQUEST_TYPE,
  LB_TBL_COL_STATUS_REASON,
  LB_TBL_COL_DATE_OF_REQUEST
} = LB_LOP_OVERTIME_TABLE_COLS;

const { ADMIN, HR } = ROLES;
const { LB_EDIT_KPI } = LB_HEADER;
const { TOAST_ERROR } = TOAST_TYPE;
const { DESC, ASC } = GLOBAL;
const { APPROVED, REJECTED } = LOP_AND_OVERTIME_STATUS;
const { SR_EMPLOYEE_NAME } = LB_EMPLOYEE_TABLE_COLS_SORT;
const { LB_DELETE_LOP_OVERTIME, LB_DELETE_LOP_OVERTIME_MESSAGE } = INPUT_LABEL;

const lopOvertimeTableStyles = {
  ...sharedTableStyles,
  headCells: {
    style: {
      ...sharedTableStyles.headCells.style,
      color: '#334155',
      fontWeight: 700
    }
  },
  rows: {
    ...sharedTableStyles.rows,
    style: {
      ...sharedTableStyles.rows.style,
      color: '#6b7280'
    }
  },
  cells: {
    style: {
      ...sharedTableStyles.cells.style,
      color: '#6b7280',
      fontWeight: 600
    }
  }
};

let columnsT = '';

const LopAndOvertimeRequestTable = () => {
  const dispatch = useDispatch();
  const lopOvertimeState = useSelector((state) => state.lopOvertimeRequest);

  const { data: isLogin } = useIsLoggedInQuery();

  const {
    isLoading,
    isFetching,
    refetch: lopOvertimeFetch,
    data: lopOvertimeRequestData
  } = useGetLopOvertimeRequestQuery({
    search: lopOvertimeState?.search || '',
    skip: skipRow(lopOvertimeState?.currentPage, lopOvertimeState?.rowsPerPage),
    limit: lopOvertimeState?.rowsPerPage,
    sort: lopOvertimeState?.sortField,
    sortType: lopOvertimeState.sortDirection ? DESC : ASC
  });

  const [deleteLopOvertimeRequest] = useDeleteLopOvertimeRequestMutation();

  columnsT = [
    ...([ADMIN, HR].includes(isLogin.data?.hrxRole?.roleName)
      ? [
          {
            name: LB_TBL_COL_NAME,
            sortField: SR_EMPLOYEE_NAME,
            selector: () => {},
            sortable: true,
            cell: (row) => (
              <div>
                <span className="lop-request-name">{row?.user?.name || ''}</span>
              </div>
            )
          }
        ]
      : []),
    {
      name: LB_TBL_COL_CLAIM_DATE,
      selector: (row) => row?.claimDate,
      cell: (row) => <div>{row?.claimDate ? formatDate(row.claimDate, 'DD-MM-YYYY') : ''}</div>
    },
    {
      name: LB_TBL_COL_DATE_OF_REQUEST,
      selector: (row) => row?.dateOfRequest,
      cell: (row) => (
        <div>
          <span className="ms-1">
            {row?.dateOfRequest ? formatDate(row.dateOfRequest, 'DD-MM-YYYY') : ''}
          </span>
        </div>
      )
    },
    {
      name: LB_TBL_COL_REQUEST_TYPE,
      selector: (row) => row?.requestType,
      cell: (row) => (
        <div>
          <span className="ms-1">{row?.requestType || ''}</span>
        </div>
      )
    },
    {
      name: LB_TBL_COL_DAYS,
      selector: (row) => row?.days,
      cell: (row) => (
        <div>
          <span className="ms-1">{row?.days || ''}</span>
        </div>
      )
    },
    {
      name: LB_TBL_COL_REASON,
      selector: (row) => row?.reason,
      cell: (row) => (
        <div>
          <span className="ms-1">{row?.reason || '-'}</span>
        </div>
      )
    },
    {
      name: LB_TBL_COL_STATUS_REASON,
      selector: (row) => row?.statusReason,
      cell: (row) => (
        <div>
          <span className="ms-1">{row?.statusReason || '-'}</span>
        </div>
      )
    },
    {
      name: LB_TBL_COL_ACTION,
      selector: () => {},
      sortable: false,
      cell: (row) => {
        const isAdminHr = [ADMIN, HR].includes(isLogin.data?.hrxRole?.roleName);
        return (
          <RowActionMenu
            actions={[
              {
                label: 'Edit',
                icon: 'icofont-edit',
                variant: 'success',
                onClick: () => {
                  handleSetEditData(row);
                }
              },
              {
                label: LB_LOP_OVERTIME_MODULE.LB_APPROVED_LOP_OVERTIME,
                icon: 'icofont-check-circled',
                variant: 'success',
                hidden: !isAdminHr,
                disabled: row.status === APPROVED,
                onClick: () => {
                  dispatch(
                    setState({
                      ...lopOvertimeState,
                      isApprovedModel: { model: true, lopOvertimeId: row?._id }
                    })
                  );
                }
              },
              {
                label: LB_LOP_OVERTIME_MODULE.LB_REJECT_LOP_OVERTIME,
                icon: 'icofont-close-circled',
                variant: 'danger',
                hidden: !isAdminHr,
                disabled: row.status === REJECTED,
                onClick: () => {
                  dispatch(
                    setState({
                      ...lopOvertimeState,
                      isRejectedModel: { model: true, lopOvertimeId: row?._id }
                    })
                  );
                }
              },
              {
                label: 'Delete',
                icon: 'icofont-ui-delete',
                variant: 'danger',
                onClick: () => {
                  dispatch(
                    setState({ ...lopOvertimeState, isDelete: { id: row?._id, status: true } })
                  );
                }
              }
            ]}
          />
        );
      }
    }
  ];

  useEffect(() => {
    lopOvertimeFetch();
  }, []);

  const handleSetEditData = async (row) => {
    dispatch(
      setState({
        ...lopOvertimeState,
        isModal: { model: true, submit: false },
        editLopOvertimeData: row,
        modalHeader: {
          title: LB_EDIT_KPI,
          isEdit: true
        }
      })
    );

    if (row?._id) {
      handleEditLopOvertime(row);
    }
  };

  const handleEditLopOvertime = async (row) => {
    dispatch(selectedLopOvertimeRequest(row));
  };

  const debouncedOnSearchData = _debounce((data) => {
    dispatch(setState({ ...lopOvertimeState, search: data }));
  }, 300);

  const handleChangeRowsPerPage = (newRowsPerPage) => {
    dispatch(setState({ ...lopOvertimeState, rowsPerPage: newRowsPerPage, currentPage: 1 }));
  };

  const handleChangePage = (page) => {
    dispatch(setState({ ...lopOvertimeState, currentPage: page }));
  };

  const handleDeleteKPI = (id) => {
    try {
      deleteLopOvertimeRequest(id).then((res) => {
        if (res?.data?.success) {
          lopOvertimeFetch();
          dispatch(setState({ ...lopOvertimeState, isDelete: { id: '', status: false } }));
        }
      });
    } catch (error) {
      notification(error.message, TOAST_ERROR);
    }
  };

  const handleChangeSort = (sortField) => {
    dispatch(
      setState({
        ...lopOvertimeState,
        sortDirection: !lopOvertimeState.sortDirection,
        sortField: sortField.sortField
      })
    );
  };

  return (
    <div className="row clearfix g-3">
      <div className="col-sm-12">
        <TableCard>
          <TableToolbar
            onSearch={debouncedOnSearchData}
            actions={
              <button
                type="button"
                className="app-table-toolbar__add-btn"
                onClick={() => {
                  dispatch(
                    setState({
                      ...lopOvertimeState,
                      isModal: { model: true, submit: false },
                      editLopOvertimeData: {},
                      selectedLopOvertimeRequestData: {},
                      modalHeader: {
                        title: LB_LOP_OVERTIME_MODULE.LB_LOP_OVERTIME_TITLE,
                        isEdit: false,
                        editId: ''
                      }
                    })
                  );
                }}
              >
                <i className="icofont-plus-circle"></i>
                {BT_BUTTON_LABELS.BTN_ADD_LOP_OVERTIME_REQUEST}
              </button>
            }
          />
          <div className="card-body">
            <div className="lop-request-table">
              <DataTable
                customStyles={lopOvertimeTableStyles}
                title={DepartmentsData.title}
                columns={columnsT}
                data={lopOvertimeRequestData?.data || []}
                defaultSortField="title"
                pagination
                paginationServer
                onSort={handleChangeSort}
                sortField={lopOvertimeState.sortField}
                sortDirection={lopOvertimeState.sortDirection}
                paginationTotalRows={paginationRow(
                  // lopOvertimeState.isNext,
                  lopOvertimeRequestData?.isNext,
                  lopOvertimeState.rowsPerPage,
                  lopOvertimeState.currentPage,
                  lopOvertimeRequestData?.data?.length
                )}
                paginationPerPage={lopOvertimeState.rowsPerPage}
                paginationRowsPerPageOptions={[5, 10, 20, 30]}
                paginationComponentOptions={{
                  noRowsPerPage: false,
                  rangeSeparatorText: 'of',
                  selectAllRowsItem: lopOvertimeState.isNext,
                  selectAllRowsItemText: 'All',
                  paginationButtonsDisabled: lopOvertimeState.isNext
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                selectableRows={false}
                className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                highlightOnHover={true}
                noDataComponent={<EmptyData />}
                progressPending={isLoading || isFetching ? true : false}
                progressComponent={<TableSkeleton columns={6} />}
              />
            </div>
          </div>
        </TableCard>
        <DeleteModel
          variant="panel"
          isOpen={() => {
            dispatch(setState({ ...lopOvertimeState, isDelete: { id: '', status: false } }));
          }}
          open={lopOvertimeState?.isDelete?.status}
          title={LB_DELETE_LOP_OVERTIME}
          message={LB_DELETE_LOP_OVERTIME_MESSAGE}
          isDelete={() => {
            handleDeleteKPI(lopOvertimeState?.isDelete.id);
          }}
        />
        <LopAndOvertimeRequestApprovedModel />
        <LopAndOvertimeRequestRejectedModel />
      </div>
    </div>
  );
};

export default LopAndOvertimeRequestTable;
